<template>
  <v-list-item-content>
    <v-list-item-title>사용중인 바이엘 제품명</v-list-item-title>
    <v-text-field
      placeholder="제품을 선택해주세요"
      ref="refProductName"
      solo
      :height="formHeight"
      required
      v-model="selectedValue"
      @click="openSelect('사용중인 바이엘 제품 선택', items)"
    >
      <template v-slot:append>
        <v-btn
          x-small
          depressed
          rounded
          @click="openSelect('사용중인 바이엘 제품 선택', items)"
        >
          선택</v-btn
        >
      </template>
    </v-text-field>
  </v-list-item-content>
</template>
<script>
export default {
  props: {
    userData: {
      type: Object,
    },
    items: {
      type: [Object, Array],
    },
    formHeight: {
      type: Number,
    },
    orderNum: {
      type: Number,
    },
    selectedValue: {
      type: String,
    },
  },
  methods: {
    openSelect(title, items) {
      console.log("openSelect");
      this.$emit("openSelect", title, items);
    },
  },
};
</script>
<style lang="">
</style>